import { PickupRequestReason } from "../../../types";

export const OTHER_REASON_MAX_LENGTH = 100;

const OTHER_REASON_CODE = "Other";

export const isOtherReasonRequired = (
  reasonIds: number[],
  reasons: PickupRequestReason[]
): boolean => {
  const otherReason = reasons.find(
    (reason) => reason.code === OTHER_REASON_CODE
  );

  return !!otherReason && reasonIds.includes(otherReason.reasonId);
};

export const validateOtherReasonText = (
  reasonIds: number[],
  otherReasonText: string,
  reasons: PickupRequestReason[]
): string | null => {
  if (isOtherReasonRequired(reasonIds, reasons) && !otherReasonText.trim()) {
    return "pickupRequests.createDialog.otherReasonRequired";
  }

  return null;
};
